<!--
 * @LastEditTime: 2023-10-20 10:46:21
-->
<template>
  <v-container fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">配件管理</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">配件列表</v-subheader>
            <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click.stop="addParts">
              <v-icon left>mdi-plus</v-icon>
              新增
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <div class="table-filter">
              <div class="box">
                <span class="label">Code</span>
                <v-text-field v-model="filterForm.code" outlined placeholder="请输入" solo></v-text-field>
              </div>
              <div class="box">
                <span class="label">名称</span>
                <v-text-field v-model="filterForm.name" outlined placeholder="请输入" solo></v-text-field>
              </div>
              <!-- <div class="box">
                <span class="label">类型</span>
                <v-select v-model="filterForm.type" outlined :items="partsTypeList" label="请输入" solo></v-select>
              </div> -->
              <v-btn @click.stop="reset" class="margin-left-2x">重 置</v-btn>
              <v-btn color="primary" @click.stop="getList('filter')" class="margin-left-2x">查 询</v-btn>
            </div>
            <!-- :server-items-length="totalDesserts" -->
            <v-data-table :headers="headers" :items="desserts" :options.sync="pagination" :loading="loading" class="elevation-1" :server-items-length="totalDesserts">
              <template v-slot:[`item.partsType`]="{ item }">
                <!-- <span> {{item}} </span> -->
                <span v-if="item.partsType">{{ partsTypeList.find(e => e.value === item.partsType).text }}</span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'detail')">查看</v-btn>
                <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'edit')">编辑</v-btn>
                <v-btn class="ma-2 white--text" small color="error" @click="clickAction(item, 'delete')">删除</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">删除配件</span>
        </v-card-title>
        <v-card-text class="pb-0">
          确定要删除{{ currentItem.name }}配件？
          <br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="deleteDialog = false" text>取消</v-btn>
          <v-btn color="error" @click="deleteItem" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="checkDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">配件详情</span>
        </v-card-title>
        <v-card-text class="pay-modal-detail" v-if="currentItem">
          <div class="base-info">
            <p>code：{{ currentItem.code }}</p>
            <p>名称：{{ currentItem.name }}</p>
            <p v-if="currentItem.partsType">类型：{{ partsTypeList.find(e => e.value === currentItem.partsType).text }}</p>
          </div>
          <div class="right" v-if="currentItem.config">
            <div class="item">
              <span class="label">表单配置项:</span>
              <div class="item-r">
                <ul class="form-ul">
                  <li v-for="(formItem, index) in JSON.parse(currentItem.config)" :key="index">
                    <span class="label">{{ formItem.title }}：</span>
                    <div class="v-input-box">
                      <v-text-field placeholder="请输入" v-model="formItem.value" solo required disabled></v-text-field>
                      <p class="inputInfo">{{ formItem.info }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ edit ? '编辑' : '新增' }}配件</span>
        </v-card-title>
        <v-card-text class="pay-modal-detail">
          <div class="base-info">
            <v-form v-model="valid" ref="form">
              <ul class="form-ul">
                <li class="required">
                  <span class="label">code：</span>
                  <div class="v-input-box">
                    <v-text-field ref="label" placeholder="请输入" v-model="form.code" solo required></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">名称：</span>
                  <div class="v-input-box">
                    <v-text-field ref="value" placeholder="请输入" v-model="form.name" solo required></v-text-field>
                  </div>
                </li>
                <li class="required">
                  <span class="label">类型：</span>
                  <div class="v-input-box">
                    <!-- <v-radio-group v-model="form.partsType" mandatory row>
                      <v-radio label="钱箱" value="cashBox"></v-radio>
                      <v-radio label="补卡机" value="cardFeeder"></v-radio>
                      <v-radio label="读卡器" value="cardReader"></v-radio>
                    </v-radio-group> -->
                    <v-radio-group v-model="radioGroup" mandatory row :rules="[v => !!v || '必须选择一个选项']">
                      <v-radio v-for="n in partsTypeList" :key="n.value" :label="n.text" :value="n.value"></v-radio>
                    </v-radio-group>
                  </div>
                </li>
              </ul>
            </v-form>
          </div>
          <div>
            <h2 class="">表单配置项:</h2>
            <div class="">
              <div class="text-right designer-top">
                <v-btn class="ma-2 white--text" small outlined color="blue" @click="importJsonDialog = true">导入Json</v-btn>
                <v-btn class="ma-2 white--text" small outlined color="blue" @click="getJson">查看Json</v-btn>
              </div>
              <fc-designer ref="designer">
                <template slot="handle"></template>
              </fc-designer>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="addDialog = false" text>取消</v-btn>
          <v-btn color="primary" @click="addEditSubmit" text :disabled="!form.code || !form.name">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="importJsonDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">导入Json</span>
        </v-card-title>
        <v-card-text class="pb-0 jsoneditor-vue-content">
          <vue-json-editor v-model="importInstallConfig" :show-btns="true" :mode="'code'" lang="zh" @json-save="onJsonSave"></vue-json-editor>
        </v-card-text>
        <v-card-actions class="footer-jsonedittor">
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="importJsonDialog = false" text>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="jsonDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">查看Json</span>
        </v-card-title>
        <v-card-text class="pb-0 jsoneditor-vue-content">
          <vue-json-editor v-model="installConfig" :show-btns="false" :mode="'code'" lang="zh"></vue-json-editor>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="jsonDialog = false" text>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import vueJsonEditor from 'vue-json-editor'
const request = buildAxios()
export default {
  name: 'partsList',
  components: {
    vueJsonEditor
  },
  data () {
    return {
      totalDesserts: 0,
      pagination: { page: 1, itemsPerPage: 10 },
      loading: true,
      partsTypeList: [],
      filterForm: {
        code: '',
        name: ''
        // type: ''
      },
      headers: [
        { text: '配件Code', value: 'code' },
        { text: '名称', value: 'name' },
        { text: '配件类型', value: 'partsType' },
        { text: '操作', value: 'actions' }
      ],
      desserts: [],
      deleteDialog: false,
      currentItem: {},
      checkDialog: false,
      addDialog: false,
      edit: false,
      valid: true,
      radioGroup: 1,
      form: {
        code: '',
        name: '',
        partsType: ''
      },
      rules: {
        code: [v => !!v || '请填写配件Code'],
        name: [v => !!v || '请填写配件名称']
      },
      importJsonDialog: false,
      importInstallConfig: [],
      jsonDialog: false,
      installConfig: {}
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getList()
      },
      deep: true
    }
  },
  created () {
    this.partsTypeList = window.partsTypeConfig
  },
  methods: {
    // 重置
    reset () {
      Object.keys(this.filterForm).forEach(key => {
        this.filterForm[key] = ''
      })
    },
    addEditSubmit () {
      if (this.edit) {
        this.editSubmit()
      } else {
        this.addSubmit()
      }
    },
    // 配件列表
    getList (type) {
      this.loading = false
      let str = ''
      if (type === 'filter') {
        this.pagination.page = 1
        Object.keys(this.filterForm).map(key => {
          if (this.filterForm[key]) {
            str = str + '&' + key + '=' + this.filterForm[key]
          }
        })
      }
      request
        .get('parts/page?page=' + (this.pagination.page - 1) + '&size=' + this.pagination.itemsPerPage + str)
        .then(res => {
          this.loading = false
          this.totalDesserts = res.data.data.totalSize
          const data = res.data.data.data
          this.desserts = data
          console.log('配件列表-----', data)
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // 添加
    addParts () {
      this.form = {
        code: '',
        name: '',
        partsType: '',
        config: ''
      }
      this.$nextTick(function () {
        this.$refs.designer.setRule([])
      })
      this.radioGroup = 1
      this.edit = false
      this.addDialog = true
    },
    addSubmit () {
      this.form.config = JSON.stringify(this.$refs.designer.getRule())
      this.form.partsType = this.radioGroup
      console.log('添加的内容', this.form, this.$refs.designer.getRule())
      request
        .post('parts/add', this.form)
        .then(res => {
          this.addDialog = false
          this.$emit('alert', {
            msg: '添加成功',
            type: 'success'
          })
          this.pagination.page = 1
          this.getList()
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // 编辑
    editSubmit () {
      this.form.config = JSON.stringify(this.$refs.designer.getRule())
      if (this.currentItem) {
        this.form.name = this.currentItem.name
        this.form.code = this.currentItem.code
        this.form.partsType = this.radioGroup
      }
      // console.log('编辑editSubmit----', this.form, this.radioGroup)
      request
        .post('/parts/edit', this.form)
        .then(res => {
          this.addDialog = false
          this.$emit('alert', {
            msg: '编辑成功',
            type: 'success'
          })
          this.pagination.page = 1
          this.getList()
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // 操作
    clickAction (item, type) {
      this.currentItem = item
      sessionStorage.setItem('partsDetail', JSON.stringify(item))
      if (type === 'detail') {
        this.checkDialog = true
      } else if (type === 'edit') {
        console.log('编辑----', item)
        this.form = item
        this.radioGroup = item.partsType
        this.edit = true
        this.addDialog = true
        this.$nextTick(function () {
          this.$refs.designer.setRule(item.config || [])
        })
      } else if (type === 'delete') {
        this.deleteDialog = true
      }
    },
    // 删除
    deleteItem () {
      this.deleteDialog = false
      console.log('配件删除-----', this.currentItem.code)
      request
        .post('parts/delete', { code: this.currentItem.code })
        .then(res => {
          this.deleteDialog = false
          this.getList()
          this.$emit('alert', {
            msg: '删除成功',
            type: 'success'
          })
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    //
    onJsonSave (value) {
      this.$refs.designer.setRule(value)
      this.importJsonDialog = false
    },
    getJson () {
      this.installConfig = this.$refs.designer.getRule()
      this.jsonDialog = true
    }
  }
}
</script>
<style scoped></style>
